var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main",attrs:{"id":"app"}},[(!_vm.isYF)?_c('v-header',{ref:"header",attrs:{"header-fixed":_vm.headerFixed}}):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"main-content"}),_vm._v(" "),(!_vm.isYF)?_c('v-footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f06384e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 